import axiosInstance from "./axiosInstance";

const permissionService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post("/permissions/create", payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get("/permissions/all");
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchSingle: async (id) => {
        try {
            const response = await axiosInstance.get(`/permissions/single/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/permissions/update/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    activate: async (id) => {
        try {
            const response = await axiosInstance.put(`/permissions/activate/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    deactivate: async (id) => {
        try {
            const response = await axiosInstance.put(`/permissions/deactivate/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/permissions/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
};

export default permissionService;
